/**
 * CalcSectionHeader — shared header for BusinessCalc section cards.
 *
 * Matches the NexTruck design language: icon in a soft amber square on the
 * left, uppercase section title with a small description underneath, and a
 * chevron on the right that toggles collapse.
 */
import React from 'react';
import { CardHeader, CardTitle, CardDescription } from '../ui/card';
import { ChevronDown } from 'lucide-react';

const CalcSectionHeader = ({
  icon: Icon,
  title,
  description,
  expanded = true,
  onToggle,
  actions,
  testId,
}) => (
  <CardHeader
    className={`cursor-pointer select-none ${expanded ? 'border-b border-border/60' : ''}`}
    onClick={onToggle}
    data-testid={testId}
  >
    <div className="flex items-center justify-between gap-3">
      <div className="flex items-center gap-3 min-w-0">
        {Icon && (
          <div className="h-11 w-11 rounded-xl bg-primary/10 text-primary flex items-center justify-center flex-shrink-0">
            <Icon className="w-5 h-5" />
          </div>
        )}
        <div className="min-w-0">
          <CardTitle className="font-heading text-xs font-extrabold uppercase tracking-[0.14em] text-foreground">
            {title}
          </CardTitle>
          {description && (
            <CardDescription className="mt-0.5 text-sm">{description}</CardDescription>
          )}
        </div>
      </div>
      <div className="flex items-center gap-2 flex-shrink-0">
        {actions}
        <ChevronDown
          className={`w-5 h-5 text-muted-foreground transition-transform ${expanded ? '' : '-rotate-90'}`}
        />
      </div>
    </div>
  </CardHeader>
);

export default CalcSectionHeader;
